import { EventSeriesData } from '@beat-venues/common-types';
import { useTranslation } from 'next-i18next';
import { Fragment, useState, type JSX } from 'react';
import { type VariantProps, tv } from 'tailwind-variants';

import { Button, Heading } from '../../atoms';
import type { CommonProps } from '../../types';
import { Modal } from '../modal';

export interface EventSeriesSensoryIconsProps
    extends CommonProps,
        VariantProps<typeof EventSeriesSensoryIconsStyles> {
    tags: EventSeriesData['tags'];
}

export const EventSeriesSensoryIconsStyles = tv({
    slots: {
        root: 'flex gap-4',
    },
    variants: {},
});

export const EventSeriesSensoryIcons = ({
    className,
    testId = 'event-series-sensory-icons',
    tags,
}: EventSeriesSensoryIconsProps): JSX.Element => {
    const { root } = EventSeriesSensoryIconsStyles();
    const { t } = useTranslation('event');
    const [modalIsShown, setModalIsShown] = useState(false);

    return (
        <div className={root({ className })} data-testid={testId}>
            <ul className="flex flex-wrap gap-2">
                {tags &&
                    tags.map((tag) => (
                        <li key={tag.name.toLowerCase()} className="relative">
                            <img
                                alt={tag.description}
                                className="w-10"
                                src={`${tag.image}`}
                            />
                        </li>
                    ))}
            </ul>
            <Button
                aria-expanded={modalIsShown}
                className="inline-block self-center"
                size="xs"
                onClick={() => setModalIsShown(true)}
            >
                <span aria-hidden="true">i</span>
                <span className="sr-only">
                    {t('sensoryWarnings.moreInformation')}
                </span>
            </Button>
            <Modal
                isShown={modalIsShown}
                onClose={() => setModalIsShown(false)}
            >
                <Modal.Header onClose={() => setModalIsShown(false)}>
                    <Heading as="h2" className="mb-0" size="h4">
                        {t('sensoryWarnings.title')}
                    </Heading>
                </Modal.Header>
                <Modal.Content>
                    <dl className="grid grid-cols-2 grid-cols-[auto_1fr] items-center gap-4">
                        {tags &&
                            tags.map((tag) => (
                                <Fragment key={tag.name.toLowerCase()}>
                                    <dt>
                                        <img
                                            alt={tag.name}
                                            className="w-10"
                                            src={`${tag.image}`}
                                        />
                                    </dt>
                                    <dd className="grow">{tag.description}</dd>
                                </Fragment>
                            ))}
                    </dl>
                </Modal.Content>
            </Modal>
        </div>
    );
};
